import { cn } from "@/lib/class-control"
import { ReactNode, ComponentProps, forwardRef } from "react";

export type TFocus = "none" | "primary" | "secondary"

interface InputProps extends ComponentProps<"input"> {
  start?: ReactNode
  end?: ReactNode
  focus?: TFocus
  classNameContainer?: string 
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, classNameContainer, start, end, focus: focusProp, type, disabled, ...props }, ref) => {
    const focus: Record<TFocus, string> = {
      "primary": "focus-within:ring-1 focus-within:ring-primary",
      "secondary": "focus-within:ring-1 focus-within:ring-primary",
      "none": "focus-within:ring-0"
    }

    return (
      <div className={cn("flex items-center w-full px-input-x py-input-y rounded-lg bg-darkblue text-white overflow-hidden",
        "border-0.5 border-gray-600 focus-within:ring-offset-0",
        disabled && "opacity-50 bg-darkblue",
        focus[focusProp || "primary"],
        classNameContainer
      )}>
        {start && start}
        <input
          type={type}
          disabled={disabled}
          className={cn(
            "flex-1 bg-transparent outline-none text-sm text-white placeholder:text-[#d1d1d1]",
            "disabled:cursor-not-allowed",
            "autofill:bg-transparent autofill:shadow-[0_0_0_1000px_#15203c_inset] autofill:[-webkit-text-fill-color:#fff]",
            "[&:-webkit-autofill]:bg-transparent [&:-webkit-autofill]:shadow-[0_0_0_1000px_#15203c_inset] [&:-webkit-autofill]:[-webkit-text-fill-color:#fff]",
            "[&:-webkit-autofill:hover]:shadow-[0_0_0_1000px_#15203c_inset] [&:-webkit-autofill:focus]:shadow-[0_0_0_1000px_#15203c_inset]",
            start && "ml-4",
            className
          )}
          ref={ref}
          {...props}
        />
        {end && end}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
